import React, { useEffect } from "react";
import { Check, Phone } from "lucide-react";
import { initRecruitingPixel } from "@/pages/LandingSalesAgent";

const RECRUITING_PIXEL = "518300620850778";

export default function LandingSalesAgentDanke() {
  useEffect(() => {
    document.title = "Danke — deine Bewerbung ist eingegangen";
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", "noindex, nofollow");
    initRecruitingPixel();
    let fired = false;
    const track = () => {
      if (fired || !initRecruitingPixel()) return;
      fired = true;
      window.fbq("trackSingle", RECRUITING_PIXEL, "CompleteRegistration", {
        content_name: "Sales Agent Brühl",
        status: "completed",
      });
    };
    track();
    window.addEventListener("el-consent", track);
    window.scrollTo(0, 0);
    return () => window.removeEventListener("el-consent", track);
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-[#16202b] text-white" data-testid="sa-danke">
      <div className="flex flex-1 items-center px-6 py-20 md:px-10">
        <div className="mx-auto max-w-[680px]">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FFD400]">
            <Check size={30} strokeWidth={3.2} className="text-[#16202b]" />
          </span>
          <h1 className="mt-8 text-[34px] font-extrabold leading-[1.1] md:text-[46px]" data-testid="sa-danke-h1">
            Danke — deine Bewerbung ist <span className="text-[#FFD400]">eingegangen.</span>
          </h1>
          <p className="mt-6 text-[18px] leading-[1.7] text-white/75">
            Wir schauen uns deine Angaben an und melden uns innerhalb von 24 Stunden telefonisch bei dir. Halte dein
            Telefon bereit — oft rufen wir noch am selben Tag an.
          </p>
          <a
            href="tel:+4921714013650"
            data-testid="sa-danke-phone"
            className="mt-9 inline-flex items-center gap-3 rounded-[6px] bg-[#FFD400] px-7 py-4 text-[17px] font-extrabold text-[#16202b]"
          >
            <Phone size={18} strokeWidth={2.6} />
            02171 4013650
          </a>
          <p className="mt-5 text-[14.5px] text-white/45">Du willst schneller starten? Ruf uns einfach direkt an.</p>
        </div>
      </div>
      <footer className="border-t border-white/10 px-6 py-7 text-center md:px-10">
        <p className="text-[12px] text-white/35">
          ONEVOLT Energy GmbH · Borsigstraße 1 · 51381 Leverkusen ·{" "}
          <a href="/impressum/" target="_blank" rel="noopener noreferrer" className="underline hover:text-white/60">
            Impressum
          </a>{" "}
          ·{" "}
          <a href="/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer" className="underline hover:text-white/60">
            Datenschutz
          </a>
        </p>
      </footer>
    </div>
  );
}
